import { createSlice } from "@reduxjs/toolkit";
import { createGenericReducers, errorSideEffects, RTKSideEffectSchema, successSideEffects, updatingSideEffects } from "../..";
import { APIErrorResponseSchema } from "../../../actions";
import { Toastify } from "../../../../components/Toaster";
import { getOutcomeTrackingState, getRequestTrackingState, MutationTrackingState } from "../../../../services/analytics/tracking";

export interface DomainAccessRestrictionState extends RTKSideEffectSchema, APIErrorResponseSchema, MutationTrackingState {
  Data?: {
    RegistrationRestrictionType: string;
  };
}

const initialState: DomainAccessRestrictionState = {
  isLoading: false,
  isUpdating: false,
  isSuccess: false,
  isError: false,
  error: null,
  Data: null
};

const domainAccessManagementSlice = createSlice({
  name: "domainAccessRestriction",
  initialState,
  reducers: {
    getDomainAccessRestrictionRequest: createGenericReducers<DomainAccessRestrictionState, any>({}).request,
    getDomainAccessRestrictionSuccess: createGenericReducers<DomainAccessRestrictionState, any>({}).success,
    getDomainAccessRestrictionError: createGenericReducers<DomainAccessRestrictionState, string>({}).failure,
    updateDomainAccessRestrictionRequest(state, action) {
      Object.assign(state, updatingSideEffects, getRequestTrackingState(action));
    },
    updateDomainAccessRestrictionSuccess(state, action) {
      Object.assign(state, successSideEffects, getOutcomeTrackingState(state, "success"));
      state.Data = action.payload;
      Toastify("success", "Domain Access Restriction Updated successfully");
    },
    updateDomainAccessRestrictionError(state, action) {
      Object.assign(state, errorSideEffects, getOutcomeTrackingState(state, "error"));
      state.error = action.payload;
    }
  }
});

export const {
  getDomainAccessRestrictionRequest,
  getDomainAccessRestrictionSuccess,
  getDomainAccessRestrictionError,
  updateDomainAccessRestrictionRequest,
  updateDomainAccessRestrictionSuccess,
  updateDomainAccessRestrictionError
} = domainAccessManagementSlice.actions;

export default domainAccessManagementSlice.reducer;
